import Image from "next/image";
import {realtorListingHref} from "@/lib/listing-url";

/** CREA's "Powered by REALTOR.ca" logo, loaded from CREA's address and left unaltered (rule 6(a)(i)). */
export const REALTOR_LOGO_URL = "https://www.realtor.ca/images/en-ca/powered_by_realtor.svg";

/**
 * The "Powered by REALTOR.ca" logo, 90 by 90 CSS pixels, linking to the
 * listing's own page on REALTOR.ca (its `ListingURL`) in a new tab. Without a
 * link (`href` null, or not an https realtor.ca address once a missing scheme is
 * added, see `realtorListingHref`) the logo is shown on its own. It never shrinks
 * below 90 by 90, whatever sits beside it.
 */
export function RealtorLogo({href: rawHref}: {href: string | null}) {
    const href = realtorListingHref(rawHref);
    const logo = (
        <Image
            src={REALTOR_LOGO_URL}
            alt="Powered by REALTOR.ca"
            width={90}
            height={90}
            unoptimized
            className="h-[90px] w-[90px] max-w-none shrink-0"
        />
    );
    if (!href) return logo;
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" className="inline-block shrink-0"
           aria-label="Powered by REALTOR.ca (opens this listing on REALTOR.ca in a new tab)">
            {logo}
        </a>
    );
}
